import React, { useEffect, useState } from 'react';

//Material
import CloseIcon from '@mui/icons-material/Close';

import { Box, Grid, Modal, Typography } from '@mui/material';

import { StyledLabel } from '../../components/StyledComponents';
import { connect, useDispatch } from 'react-redux';
import { LetsGoBtn } from '../../components/Buttons';
import { setIsOpenDeleteModal } from '../../redux/mainReducer';

import './DeleteModal.css';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: { xs: 390, sm: 710, md: 820, lg: 900, xl: 900 },
  minWidth: 390,

  bgcolor: 'background.paper',
  borderRadius: '20px',
  border: 'none',
  boxShadow: 24,
  padding: { xs: '20px ', md: '50px 60px 50px 60px' },
  overflow: 'scroll',
  height: 'inherit',
  maxHeight: '100vh',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none'
  }
};

function DeleteModal({ isOpenModal, func, text, id }) {
  const [randomPhrase, setRandomPhrase] = useState(0);
  const dispatch = useDispatch();
  const phrases = [
    'Диму без вогню не буває, як і видалення без причини. Видаляємо',
    'Аби й очі не бачили! Видаляємо',
    'Подумай тричі й один раз відріж. Видаляємо'
  ];
  useEffect(() => {
    setRandomPhrase(Math.floor(Math.random() * phrases.length));
    // eslint-disable-next-line
  }, []);
  return (
    <div>
      <Modal
        open={isOpenModal}
        onClose={(event, reason) => {
          if (reason === 'backdropClick') {
            return;
          }

          dispatch(setIsOpenDeleteModal({ isOpen: false, text: '', func: null, id: null }));
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="bonfair_delete_modal"
      >
        <Box sx={style} className="bonfair_delete_modal-box">
          <CloseIcon
            className="bonfair_delete_modal-close"
            style={{ position: 'absolute', right: '10px', top: '10px', cursor: 'pointer' }}
            onClick={() => {
              dispatch(setIsOpenDeleteModal({ isOpen: false, text: '', func: null, id: null }));
            }}
          />

          <Grid container spacing={2}>
            <Grid item xs={12} md={12} lg={12}>
              <StyledLabel className="deleteModal-title-text">
                {/* {translate('bonfair_service_modal')} */}
                {'Видалення'}
              </StyledLabel>
            </Grid>
            <Grid item xs={12} md={12} lg={12} sx={{ display: 'flex', justifyContent: 'center' }}>
              <Typography
                variant="subtitle2"
                sx={{
                  mb: 2,
                  fontSize: 16,
                  fontFamily: 'FixelText-SemiBold',
                  fontWeight: '500',
                  textAlign: 'center',
                  maxWidth: '70%'
                }}
              >
                {`${phrases[randomPhrase]} ${text}`}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                margin: '20px auto 0px',
                maxWidth: '350px',
                flexDirection: { xs: 'column', sm: 'row', md: 'row', lg: 'row' },
                gap: '10px'
              }}
            >
              <LetsGoBtn
                colorScheme="blue"
                size="large"
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  func(id);
                  dispatch(setIsOpenDeleteModal({ isOpen: false, text: '', func: null, id: null }));
                }}
                width={'100%'}
                style={{ textTransform: 'inherit' }}
                text="Видалити"
              />
              <LetsGoBtn
                colorScheme={'white'}
                marginTop="0"
                size="large"
                onClick={() => {
                  dispatch(setIsOpenDeleteModal({ isOpen: false, text: '', func: null, id: null }));
                }}
                width={'100%'}
                style={{ textTransform: 'inherit' }}
                text="Залишити"
              />
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.Intl.locale
  };
};
export default connect(mapStateToProps)(DeleteModal);
